// @givmo/app-admin — 404 (parity with the Flutter webapp's `NotFoundScreen` / Beamer
// notFoundRedirect). Copy matches the Flutter screen verbatim: heading "Page not found", the
// "doesn't exist or has moved" body, and a "Go to home" button back to the dashboard (the Flutter
// NavigationRoute landing). Note: the Flutter 404 source uses ASCII apostrophes (unlike the privacy
// copy which is curly), so this is byte-verbatim with `not_found_screen.dart`.

import { Link } from '@tanstack/react-router';
import { testIdProp } from '@givmo/design-system';

export function NotFound() {
  return (
    <main
      className="mx-auto flex min-h-screen max-w-[32rem] flex-col items-center justify-center gap-12 px-16 text-center"
      {...testIdProp('page-not-found')}
    >
      <h1 className="text-s24 font-w700 tracking-givmo text-blue">Page not found</h1>
      <p className="text-s14 text-gray60">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link to="/" className="text-s14 font-w600 text-blue underline">
        Go to home
      </Link>
    </main>
  );
}
